import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Divider, CardMedia, Grid, Button, IconButton, Icon, useTheme } from '@mui/material';
import styled from '@emotion/styled';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';

import { formatGenericDate, formatCurrency } from '../../../utils/util';

import { SectionHeaderBar, BasicFlex, LabelUpper, autoCompleteDisplayLabel, DotSeparator } from '../../../utils/Common';

import { useFormikContext, FieldArray } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import Field from '../../../utils/FormikFields/Field';

import Dialog from '../../../utils/utilities/Dialog';

import useRepairsStore from '../../../store/repairs';

import EditRepairTicket from '../../Repair_Tickets/EditRepairTicket';

// linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);

const Container = styled.div`
  background-color: ${props => props.theme.colors.softBg};
  border-radius: 5px;
  padding: .7rem 1rem;
`

const SearchContainer = styled.div`
  margin: .5rem 0;
`
const RepairListContainer = styled(BasicFlex)`
  margin-top: 1rem;
  width: 100%;
  gap: 1rem;
`;

const StyledCard = styled(Card)`
 border-radius: 8px;
 border: 1px solid ${props => props.theme.colors.border};
 box-shadow: 0 1px 5px rgba(0, 0, 0, 0.12);
 transition: all 0.2s ease-in-out;
 overflow: hidden;
 
 &:hover {
   border-color: ${props => props.theme.colors.darkBg};
   box-shadow: 0 2px 8px rgba(25, 118, 210, 0.1);
 }
`;

const ImageContainer = styled(BasicFlex)`
  background-image: linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%);
  border-radius: 5px;
  border-right: 1px solid ${props => props.theme.colors.border};
  min-height: 8rem;
  width: 8rem;
  justify-content: center;
  align-items: center;
`;

const ServiceImage = styled('img')`
 width: 100%;
 height: 100%;
 object-fit: cover;
`;

const ServiceItemDetails = styled(BasicFlex)`
  /* min-width: fit-content; */
  /* width: auto; */
  margin-right: 4rem;
`;

const ServiceTitle = styled.div`
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1.4rem;
  /* color: ${props => props.theme.colors.mildText}; */
  /* margin-bottom: .5rem; */
`

const DetailLineStyles = styled.div`
  /* font-size: 1.4rem; */
  color: ${props => props.theme.colors.mildText};
`;

const PriceDisplay = styled(BasicFlex)`
  width: fit-content;
 .MuiInputBase-input {
    padding: .2rem !important;
  }
`

const SaveConfirmation = styled.div`
  padding: 1.6rem;
`

const ServiceActions = styled(BasicFlex)`
`;

// const AddRepairs = () => {

//   const [openRepairsDialog, setOpenRepairsDialog] = useState(false);

//   const { values, submitForm } = useFormikContext() || {};

//   const { formValues } = useFormData() || {};

//   const pendingRepairsDialog = useRepairsStore((state) => state.pendingRepairsDialog);
//   const setPendingRepairsDialog = useRepairsStore((state) => state.setPendingRepairsDialog);
//   const setInvoiceData = useRepairsStore((state) => state.setInvoiceData);

//   let is_edit = !!values?.invoice_id;

//   let invoice_data = {
//     invoice_id: values?.invoice_id,
//     customer: {
//       customer_id: values?.customer_id,
//       full_name: formValues?.client_name || values?.client_name
//     }
//   }

//   let id = `${values?.customer_id?.toString()}-repair`

//   const saveInvoice = () => {
//     setPendingRepairsDialog(id);
//     submitForm();
//   }

//   useEffect(() => {
//     if (is_edit && pendingRepairsDialog === id) {
//       console.log("open repairs dialog", is_edit, pendingRepairsDialog);
//       setOpenRepairsDialog(true);
//       setInvoiceData(invoice_data);
//     }
//   }, [is_edit, pendingRepairsDialog])


//   return (
//     <>
//     <Dialog
//       title="Confirm Save Invoice"
//       key="confirm-save-invoice"
//       disabled={!values?.customer_id}
//       toggle={(
//       <Button 
//         startIcon={<ContentCutRoundedIcon />} 
//         variant="contained" 
//         size="large" 
//         color="info" 
//         disabled={!values?.customer_id}
//       >Add Repairs</Button>
//       )}
//       saveText="Save Invoice"
//       saveFunc={saveInvoice}
//     >
//       <SaveConfirmation>
//         To Proceed to repairs, you must first save the invoice. Hit save to confirm.
//       </SaveConfirmation>
//     </Dialog>

//     <Dialog
//       title="Add Repairs"
//       key="add-repairs"
//       forceOpen={openRepairsDialog}
//       forceClose={() => setOpenRepairsDialog(false)}
//       fullScreen
//       useForm={true}
//     >
//       <EditRepairTicket dialog={true}
//         />
//     </Dialog>
//     </>
//   )
// }


const RepairLine = ({ li = {}, index, remove }) => {
  const { values } = useFormikContext() || {};
  let { name, sku, description } = li;

  const theme = useTheme();

  return (
    <StyledCard sx={{p: ".6rem !important", width: "100%", border: `1px solid ${theme.palette.info.main} !important`, borderRadius: "4px !important"}} variant='outlined'>
      <BasicFlex justify="flex-start">
        <CardContent sx={{p: ".5rem 1.6rem !important", width: "100%"}}>
         <BasicFlex justify="space-between">
         
          <ServiceItemDetails dir="column" gap=".5rem" align="flex-start">
            <ServiceTitle>{name}</ServiceTitle>
            <DetailLineStyles>{description}</DetailLineStyles>
          </ServiceItemDetails>

          <ServiceActions align="flex-end" justify="flex-end" gap="1rem">
            {/* <PriceDisplay dir="column" gap=".5rem" width="auto">
             <strong>{formatCurrency(li.calculated_amount)}</strong>
            </PriceDisplay> */}
            <PriceDisplay>
             <Field name={`repairs.${index}.rate`} type="number" InputProps={{sx: {margin: 0, width: "12rem", paddingLeft: ".5rem !important", fontSize: "1.6rem", fontWeight: "500", gap: ".5rem"}, startAdornment: <AttachMoneyRoundedIcon fontSize='small' />}} />
            </PriceDisplay>
          </ServiceActions>
         </BasicFlex>
        </CardContent>
      </BasicFlex>
      
    </StyledCard>
  )
}

const Repairs = () => {
  const { values } = useFormikContext() || {};

  let wigs = values?.wigs || [];
  let generalRepairs = values?.repairs?.filter(repair => !wigs.find(li => li.name === repair.wig_id)) || [];

  // console.log(generalRepairs, "generalRepairs");

  return (
    generalRepairs.length ? <Grid size={{xs: 12}}>
       <Container>
        <LabelUpper>Repairs</LabelUpper>
        
          <FieldArray name="wigs">
            {({ push, remove }) => (
              <>
                <RepairListContainer dir="column">
                { generalRepairs.map((repair, index) => (
                    <RepairLine key={index} li={repair} index={index} remove={remove} />
                  ))}
                </RepairListContainer>

              {/* <AddRepairs /> */}
              </>
            )}
          </FieldArray>
      </Container>
    </Grid> : null
  )
};

export default Repairs;